module.exports = __webpack_public_path__ + "img/peoples.2269979c.svg";